import { companyConfig } from "./companyConfig";

export const navItems = [
  { label: "Inicio", href: "/", type: "internal" },
  { label: "Empresa", href: "/nosotros", type: "internal" },
  { label: "Soluciones", href: "/servicios", type: "internal" },
  { label: "Novedades", href: "/noticias", type: "internal" },
  { label: "Soporte 24/7", href: companyConfig.serviceDeskUrl, type: "external" },
];

export const ctaItem = { label: "Hablemos", href: "/contacto" };
